import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { invoiceFeatureKey, invoiceReducer } from './invoice-reducer';
import { InvoiceEffects } from './effects/invoice.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideInvoiceStore = (): EnvironmentProviders[] => [
    provideState(invoiceFeatureKey, invoiceReducer),
    provideEffects([InvoiceEffects])
];
